export default __webpack_public_path__ + "static/media/spheroids_responsive.7487341e.png";